import { ethers } from 'ethers';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { contractAddress, tuesdayContractAddress } from '../constants/abi';
import { usdtContractAddress } from '../constants/usdtAbi';
import { notifyError, notifySuccess } from '../utils/toastError';
import Loader from './Loader';

const ModalBuyTicket = ({
  setShowModal,
  showModal,
  setShowModalDrawPick,
}) => {
  const {
    connect,
    lotteryContract,
    tuesdayContract,
    usdtContract,
  } = useSelector(state => state.provider);

  const { both, tuesday, friday, fridayTime, tuesdayTime } = useSelector(state => state.lotteryDay);

  const [price, setPrice] = useState('');
  const [loader, setLoader] = useState(false);
  let [count, setCount] = useState(1);

  // console.log(day?"friday":"tuesday");

  useEffect(
    () => {
      if (connect) {
        fetchPrice();
      }
    },
    [connect]
  );

  const fetchPrice = async () => {
    let priceInfo = 0;
    if (both) {
      if (parseInt(tuesdayTime) < parseInt(fridayTime)) {
        //tuesday
        priceInfo = await tuesdayContract.ticketPrice();
      } else {
        //friday
        priceInfo = await lotteryContract.ticketPrice();
      }
    } else {
      if (tuesday) {
        priceInfo = await tuesdayContract.ticketPrice();
      } else {
        priceInfo = await lotteryContract.ticketPrice();
      }
    }
    // console.log (priceInfo.toString (), 'priceInfo');
    setPrice(ethers.utils.formatEther(priceInfo.toString()));
  };

  const buyTicket = async () => {
    if (connect) {
      if (both) {
        if (parseInt(tuesdayTime) < parseInt(fridayTime)) {
          buyTuesdayTicket();
        } else {
          //friday
          buyFridayTicket();
        }
      } else {
        if (tuesday) {
          buyTuesdayTicket();
        } else {
          buyFridayTicket();
        }
      }
    } else {
      notifyError('Please Connect Metamask Wallet');
    }
  };

  const buyFridayTicket = async () => {
    const price = await lotteryContract.functions.ticketPrice();
    // console.log ('price', price.toString ());
    setLoader(true);
    const tx = await approveUsdt(contractAddress, price.toString(), lotteryContract);
    console.log("return", tx);
  };

  const buyTuesdayTicket = async () => {
    const price = await tuesdayContract.functions.ticketPrice();
    console.log('price', price.toString());
    setLoader(true);
    const tx = await approveUsdt(tuesdayContractAddress, price.toString(), tuesdayContract);
    console.log("return", tx);

  };

  const approveUsdt = async (contractAddress, p, contract) => {
    console.log("Price", (count * p).toString());
    try {
      await usdtContract.functions
        .approve(contractAddress, (count * p).toString())
        .then(tx => {
          return tx.wait(1).then(async receipt => {
            notifySuccess('Usdt Approved Successfully');
            buy(contract);

          }), error => {
            return error.checkCall().then(error => {
              console.log('Error', error);
              setLoader(false);
              notifyError(error.message);
            });
          };
        });
    } catch (error) {
      setLoader(false);
      if (error.reason) {
        console.log(error.reason);
        notifyError(error.reason);
      } else {
        console.log(error.message);
        notifyError(error.message);
      }
    }
  };

  const buy = async (contract) => {
    try {
      await contract.functions
        .buyTicket()
        .then(tx => {
          return tx.wait(1).then(receipt => {
            console.log('Transaction receipt:', receipt);
            setLoader(false);
            notifySuccess('Ticket Bought Successfully');
            setCount(1);
            setShowModalDrawPick(true);
            setShowModal(false);
          }), error => {
            return error.checkCall().then(error => {
              console.log('Error', error);
              setLoader(false);
              notifyError(error.message);
            });
          };
        });
    } catch (error) {
      setLoader(false);
      if (error.reason) {
        console.log(error.reason);
        notifyError(error.reason);
      } else {
        console.log(error.message);
        notifyError(error.message);
      }
    }
  };
  useEffect(
    () => {
      if (showModal) {
        document.body.style.overflow = 'hidden';
      } else {
        document.body.style.overflow = 'unset';
      }
    },
    [showModal]
  );

  const increment = () => {
    setCount((count += 1));
  };

  const decrement = () => {
    if (count <= 1) {
      setCount(1);
      return;
    }

    setCount((count -= 1));
  };

  return (
    <div>
      {showModal
        ? <div>
          <div className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none bg-black/80">
            <div className="relative my-6 mx-auto w-[22em] sm:w-[30em] rounded-xl">
              {/*content*/}
              <div className="border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-black outline-none focus:outline-none">
                {/*header*/}
                <div className="flex items-center justify-between p-5 border-b border-solid border-lyellow rounded-t text-lyellow">
                  <h3 className="text-2xl font-bold">Buy Tickets</h3>
                  <div className="flex justify-center items-center text-white outline-none focus:outline-none text-xl mx-2">
                    <button
                      className="text-lyellow"
                      onClick={() => setShowModal(false)}
                    >
                      X
                    </button>
                  </div>
                </div>
                {/*body*/}
                <div className="flex flex-col items-center justify-center relative  py-5 gap-y-5 text-lyellow  text-xl sm:text-2xl ">
                  <h3 className="tracking-wide font-semibold">
                    Each Ticket Price Is <span className='text-red-600'> ${price} USDT</span>
                  </h3>
                </div>
                {/*footer*/}

                <div className="flex flex-col items-center justify-center p-6 border-t border-solid border-lyellow rounded-b text-black gap-y-5">
                  <div className="flex items-center justify-between w-full ">
                    <div className="">
                      <p className="text-lyellow text-xl font-bold">
                        Total Price
                      </p>
                      <p className="text-green-600 text-3xl font-bold pt-1">
                        $ {parseFloat(parseInt(count) * price).toFixed(3)} USDT
                      </p>
                    </div>
                    <div>
                      <p className="text-lyellow text-xl font-bold text-center">
                        Tickets
                      </p>
                      <div className="flex items-center justify-center pt-1">

                        <button
                          className="bg-lyellow py-[2] px-2 rounded-lg "
                          onClick={decrement}
                        >
                          <p className="text-white text-2xl">-</p>
                        </button>
                        <input type={'number'}
                          min={1}
                          className="bg-transparent text-green-600 font-bold text-3xl text-center w-[4rem] outline-none"
                          value={count} onChange={e => {
                            console.log(e.target.value);
                            if (e.target.value.length == 0 || e.target.value <= 0) {
                              setCount(1);
                              return;
                            }
                            setCount(parseInt(e.target.value));
                          }
                          } />
                        {/* <p className="text-green-600 font-bold text-3xl mx-5">
                            {count}
                          </p> */}
                        <button
                          className="bg-lyellow py-[2] px-2 rounded-lg "
                          onClick={increment}
                        >
                          <p className="text-white text-2xl">+</p>
                        </button>

                      </div>
                    </div>
                  </div>
                  <div className="flex items-center justify-center relative  py-10 ">
                    <div className="bg-lyellow text-md font-semibold py-[3.5em] px-[2.6em] border-dotted border-r-[0.4em] border-black rounded-t-2xl rounded-b-2xl  transition ease-in duration-200 " />
                    <div className="bg-lyellow text-md font-semibold py-[3.5em] px-[5.6em] rounded-2xl border-dotted border-l-[0.4em] border-black  transition ease-in duration-200 " />

                    <button
                      className="absolute bg-[#1d2226]  text-md font-semibold py-4 px-[3.6em] hover:opacity-90 text-white hover:text-white rounded-xl"
                      onClick={buyTicket}
                    >
                      Buy Tickets
                    </button>
                  </div>
                </div>
                <div
                  onClick={() => {
                    setShowModalDrawPick(true);
                    setShowModal(false);
                  }}
                >
                  <p className="text-red-600 font-bold underline text-center pb-3 cursor-pointer">
                    Tickets already bought?
                  </p>
                </div>
              </div>
            </div>
            <div className='absolute w-full bg-black/30'>
              {loader ? <Loader /> : null}
            </div>

          </div>
        </div>
        : null}


    </div>
  );
};

export default ModalBuyTicket;
